import DeleteIcon from "@mui/icons-material/Delete";
import { Box, IconButton, TextField, useTheme } from "@mui/material";
import {
  ClientModelVariable,
  CustomClientModelVariable
} from "@services/api/types";

export interface IMediaVarCell {
  modelVar: CustomClientModelVariable | ClientModelVariable;
  handleEditMediaModelVar: (mediaVarId: number, name: string) => void;
  handleDeleteMediaVar?: (index: number) => void;
}
const MediaVarCell = ({
  modelVar,
  handleDeleteMediaVar = (_: number) => {},
  handleEditMediaModelVar
}: IMediaVarCell) => {
  const theme = useTheme();
  const is_custom = "is_custom" in modelVar && modelVar["is_custom"];

  return (
    <Box className="flex">
      <span
        className="dot"
        style={{
          backgroundColor: modelVar.color,
          height: 10,
          width: 10,
          borderRadius: "50%",
          marginTop: 5,
          marginRight: 4
        }}
      ></span>
      {is_custom && (
        <TextField
          type="text"
          variant="outlined"
          value={modelVar.name}
          onChange={(event) => {
            handleEditMediaModelVar(modelVar.id, event.target.value as string);
          }}
          required
        />
      )}
      {!is_custom && modelVar.name}
      <Box
        sx={{
          color: theme.palette.error.main,
          fontWeight: 600
        }}
      >
        {!modelVar.is_significant ? "*" : ""}
      </Box>
      {is_custom && (
        <IconButton
          color="error"
          onClick={() => handleDeleteMediaVar(modelVar.order)}
        >
          <DeleteIcon />
        </IconButton>
      )}
    </Box>
  );
};

export default MediaVarCell;
